{
    "account": {
        "menu": {
            "general_infos": "Info generali",
            "company": "Società",
            "orders_history": "Storico ordini",
            "quotes_history": "Storico preventivi",
            "invoices_history": "Storico fatture",
            "logout": "Logout"
        },
        "general_infos": {
            "title": "Informazioni generali",
            "account_infos": "Informazioni account",
            "user_name": "Nome utente",
            "user_email": "E-mail",
            "user_role": "Ruolo",
            "user_mobile": "Cellulare",
            "change_password": "Cambia password",
            "agency_infos": "Informazioni azienda",
            "customer_code": "Cod. cliente",
            "company": "Ragione sociale",
            "vat": "P.IVA",
            "activity": "Settore attività",
            "workers": "Dipendenti",
            "phone": "Telefono",
            "country": "Nazione",
            "province": "Provincia",
            "city": "Città",
            "zip": "Cap",
            "address": "Indirizzo"
        },
        "company": {
            "title": "Società",
            "company": "Ragione sociale",
            "customer_code": "Cod. cliente",
            "name": "Ragione sociale",
            "vat": "P.IVA",
            "business": "Settore attività",
            "workers": "Dipendenti",
            "phone": "Telefono",
            "country": "Nazione",
            "province": "Provincia",
            "city": "Città",
            "zip": "Cap",
            "address": "Indirizzo",
            "operational_users": "Utenti abilitati",
            "table": {
                "user_name": "Nome utente",
                "email": "Email",
                "phone": "Cellulare"
            },
            "no_companies_found": "Nessun dato trovato"
        },
        "orders_history": {
            "title": "Storico ordini",
            "label_select_company": "Visualizza ordini della società:",
            "doc_number": "Numero documento",
            "doc_number_placeholder": "es. 0046100300300",
            "from": "Da",
            "to": "a",
            "search_order": "Cerca ordine",
            "nothing_found": "Nessun ordine trovato",
            "error_reorder": "Si è verificato un errore durante l'operazione.",
            "table": {
                "order": "Ordine",
                "date": "Data",
                "total": "Totale",
                "order_status": "Stato ordine",
                "reorder": "riordina",
                "load_more": "Carica altri ordini"
            }
        },
        "quotes_history": {
            "title": "Storico preventivi",
            "label_select_company": "Visualizza preventivi della società:",
            "doc_number": "Numero documento",
            "doc_number_placeholder": "es. 0046100300300",
            "from": "Da",
            "to": "a",
            "search_quote": "Cerca preventivo",
            "nothing_found": "Nessun preventivo trovato",
            "table": {
                "quote": "Preventivo",
                "date": "Data",
                "new_offer": "Nuova offerta",
                "quote_status": "Stato preventivo",
                "load_more": "Carica altri preventivi"
            }
        },
        "invoices_history": {
            "title": "Storico fatture",
            "label_select_company": "Visualizza situazione finanziaria della società:",
            "expired_invoices": "Fatture scadute",
            "expiring_invoices": "Fatture in scadenza",
            "payment_method": "Tipo pagamento",
            "billing_address": "Indirizzo di fatturazione",
            "nothing_found": "Nessuna fattura trovata",
            "table": {
                "invoice_number": "Numero fattura",
                "date": "Data di emissione",
                "expiring_date": "Data di scadenza",
                "payment_method": "Metodo di pagamento",
                "value": "Importo da pagare",
                "invoice_status": "Stato fattura",
                "currency": "Valuta",
                "download": "Scarica",
                "load_more": "Carica altre fatture",
                "error_download": "Errore durante lo scaricamento della fattura"
            }
        },
        "order_detail": {
            "title": "Ordine",
            "go_back": "Indietro",
            "download": "Download",
            "your_reference": "Vostro riferimento",
            "date_order": "Data ordine",
            "weight": "Peso in kg",
            "payment": "Pagamento",
            "return_terms": "Termini di resa",
            "billing_address": "Indirizzo di fatturazione",
            "shipping_address": "Indirizzo di spedizione",
            "table": {
                "art_code": "Cod. Articolo",
                "art_code_customer": "Cod. Art. cliente",
                "description": "Descrizione",
                "measure_unit": "U. m.",
                "total_quantity": "Qtà tot",
                "unit_price": "Prezzo un.",
                "discount_1": "Sc. 1",
                "discount_2": "Sc. 2",
                "discount_3": "Sc. 3",
                "increase": "Mag. incr.",
                "net_unit_price": "Prezzo un. netto",
                "net_total": "Importo netto",
                "deliver_date": "Data consegna"
            }
        },
        "quote_detail": {
            "title": "Preventivo",
            "go_back": "Indietro",
            "download": "Download",
            "your_reference": "Vostro riferimento",
            "date_quote": "Data preventivo",
            "weight": "Peso in kg",
            "payment": "Pagamento",
            "return_terms": "Termini di resa",
            "billing_address": "Indirizzo di fatturazione",
            "shipping_address": "Indirizzo di spedizione",
            "table": {
                "art_code": "Cod. Articolo",
                "art_code_customer": "Cod. Art. cliente",
                "description": "Descrizione",
                "measure_unit": "U. m.",
                "total_quantity": "Qtà tot",
                "unit_price": "Prezzo un.",
                "discount_1": "Sc. 1",
                "discount_2": "Sc. 2",
                "discount_3": "Sc. 3",
                "increase": "Mag. incr.",
                "net_unit_price": "Prezzo un. netto",
                "net_total": "Importo netto",
                "deliver_date": "Data consegna"
            }
        },
        "document_status_list": {
            "pending": "in lavorazione",
            "delivering": "in consegna",
            "delivered": "consegnato",
            "processed": "evaso",
            "invoiced": "fatturato",
            "refused": "rifiutato",
            "accepted": "accettato",
            "on_customer_approve": "in approvazione cliente",
            "on_offer_progress": "in fase di offerta",
            "canceled": "cancellato",
            "expired": "scaduta",
            "expiring": "in scadenza",
            "paid": "pagata",
            "active": "attivo",
            "created": "creato",
            "approved": "approvato",
            "cancelled": "cancellato",
            "confirmed": "confermato"
        },
        "totals_component": {
            "text": "Le condizioni generali di fornitura disponibili su www.gberardi.com si applicano a tutti i contratti di vendita da parte di BERARDI BULLONERIE s.r.l. Condizioni contrattuali difformi, anche ove contenute in condizioni generali o particolari di acquisto predisposte dal cliente stesso, non trovano applicazione e non vincolano BERARDI BULLONERIE s.r.l se non accettate espressamente e per iscritto da quest’ultima",
            "products_total": "Numero articoli",
            "discount": "Sconto",
            "net_total": "Totale netto",
            "packaging": "Spese accessorie",
            "shipment": "Trasporto",
            "order_total": "Totale ordine"
        }
    },
    "cart": {
        "cart_title": "Il mio carrello",
        "login_to_receive_quotation": "Accedi o registrati per richiedere un preventivo.",
        "proceed_to_checkout": "Procedi per visualizzare il Riepilogo della richiesta.",
        "minimum_order_total": "L'importo minimo consentito per un ordine è 200,00€",
        "code": "Cod. art.",
        "details": "dettagli",
        "request_quotation": "Richiedi preventivo",
        "request_quotation_text": "Invia una richiesta di preventivo con prodotti inseriti a carrello. Sarai contattato dal nostro servizio clienti con un’offerta a te dedicata.",
        "quote_all": "Richiedi preventivo per tutti gli articoli",
        "quote": "preventivo",
        "order_detail": "Dettaglio ordine",
        "total_items": "Numero articoli",
        "subtotal": "Subtotale",
        "quantity_discount": "Sconto quantità",
        "total_no_vat": "Totale IVA esclusa",
        "vat": "IVA",
        "total": "Totale IVA inclusa",
        "quote_request": "Richiesta preventivo",
        "pieces": "Pezzi",
        "pieces_short": "pz",
        "quote_request_text": "Il subtotale calcolato è provvisorio, la richiesta di preventivo è finalizzata al ricalcolo del prezzo nel caso in cui la numerosità richiesta sia alta.",
        "proceed": "Procedi",
        "csv_box_title": "Vuoi riempire il tuo carrello in maniera massiva?",
        "csv_box_text": "Carica il tuo file .csv con i codici prodotto e la quantità desiderate.",
        "csv_box_text_instructions": "Inserisci i tuoi codici articolo, se presenti nel nostro sistema, nella colonna CUSTOMER_CODE",
        "csv_box_no_file": "Nessun file .csv caricato",
        "csv_select_file": "Seleziona file",
        "csv_download": "Download template",
        "csv_upload": "Carica",
        "unit_price": "Prezzo unitario",
        "error_uploading_csv": "Errore durante il caricamento del CSV",
        "summary": {
            "title": "Riepilogo",
            "subtitle": "Invia la richiesta al nostro servizio clienti. Potrai sempre controllare lo stato della richiesta all’interno della tua area personale.",
            "order_summary": "Riepilogo ordine",
            "addresses": "Indirizzi",
            "billing_address": "Indirizzo di fatturazione",
            "shipping_address": "Indirizzo di spedizione",
            "additional_info": "Informazioni aggiuntive",
            "your_reference": "Vostro riferimento",
            "input_reference": "Inserisci riferimento",
            "note": "Nota",
            "input_note": "Aggiungi una nota",
            "order_items": "Articoli ordine",
            "items_total": "Tot. merce",
            "discount": "Sconto",
            "order_total": "Totale ordine",
            "order_total_quote": "richiesta preventivo",
            "quote_summary": "Riepilogo preventivo",
            "input_note_quote": "Aggiungi una nota al preventivo",
            "quote_items": "Articoli preventivo",
            "disclaimer": "Le condizioni generali di fornitura disponibili su www.gberardi.com si applicano a tutti i contratti di vendita da parte di BERARDI BULLONERIE s.r.l. Condizioni contrattuali difformi, anche ove contenute in condizioni generali o particolari di acquisto predisposte dal cliente stesso, non trovano applicazione e non vincolano BERARDI BULLONERIE s.r.l se non accettate espressamente e per iscritto da quest’ultima",
            "send": "Invia",
            "error_send_order_quote": "Si è verificato un errore durante l'invio dell'ordine"
        },
        "thank_you": {
            "thank_you_title": "Grazie per averci scelto!",
            "for_more_info": "Abbiamo ricevuto con successo la tua richiesta. Potrai monitorare l’avanzamento della richiesta all’interno della tua area personale.",
            "back_to_home": "Torna alla home",
            "order_title": "Ordine",
            "order_title_failed": "Ordine inviato",
            "order_not_success": "Il tuo ordine richiede la verifica da parte di un nostro operatore. Non appena sarà terminata la verifica troverai il tuo ordine nella sezione Storico Ordini",
            "order_success": "L’ordine è stato inviato correttamente. Presto potrai monitorare lo stato all’interno della tua area personale.",
            "items_number": "Numero articoli",
            "quote_title": "Richiesta di preventivo inviata",
            "quote_success": "Nelle prossime ore riceverai la quotazione da un nostro operatore",
            "quote_not_success": "Il tuo preventivo richiede una verifica da parte nostra, non appena sarà terminata riceverai la quotazione da un nostro operatore"
        }
    },
    "product": {
        "buttons": {
            "tech_sheet_download": "Download scheda tecnica",
            "compliance_sheet_download": "Download scheda conformità"
        },
        "table_data": {
            "code": "Codice",
            "color": "Colore",
            "brand": "Brand",
            "material": "Material"
        },
        "filters": {
            "sku": "Cod. art."
        },
        "table": {
            "art_code": "Cod. Art",
            "art_code_customer": "Cod. Art. Cliente",
            "weight": "Peso",
            "pieces_per_package": "Pz per conf.",
            "unit_price": "Prezzo unitario",
            "total_price": "Prezzo totale",
            "number_of_pieces": "Numero pezzi",
            "availability": "Disponibilità",
            "associate": "Associa",
            "login_to_see_price": "Accedi per visualizzare il prezzo del prodotto",
            "pieces": "Pezzi",
            "details": "dettagli",
            "insufficient_qty": "Parz. disponibile",
            "not_available": "Non disponibile",
            "available": "Disponibile",
            "load_more_variants": "Carica altre varianti",
            "added_product": "Prodotto aggiunto al carrello: "
        },
        "clothing_selector": {
            "color": "Colore",
            "size": "Taglia",
            "unit_price": "Prezzo unitario",
            "pieces_number": "Numero pezzi",
            "total_price": "Prezzo totale",
            "add_to_cart": "Aggiungi al carrello",
            "insufficient_qty": "Parz. disponibile",
            "not_available": "Non disponibile",
            "available": "Disponibile"
        }
    },
    "modals": {
        "general": {
            "confirm": "Conferma",
            "cancel": "Annulla"
        },
        "associate_id": {
            "title": "Codice articolo cliente",
            "paragraph": "Inserisci il tuo codice cliente da associare all’articolo.",
            "customer_code": "Cod. Art. Cliente",
            "placeholder": "Inserisci codice cliente",
            "warning_text": "Attenzione! Campo modificabile una sola volta!",
            "explanation_confirm": "Controlla che il codice cliente inserito sia corretto e conferma l’associazione. In seguito non potrai più modificarlo in autonomia. In futuro per la modifica del codice sarà necessario contattare l’assistenza clienti di Berardi Bullonerie s.r.l.",
            "associate_button": "Associa"
        }
    },
    "search": {
        "search_code": "Cerca per codice...",
        "cod_art": "Codice articolo",
        "name_art": "Nome articolo",
        "no_product_found": "Nessun prodotto trovato",
        "no_query": "Scrivi nella barra di ricerca e premi INVIO per ricevere dei risultati"
    },
    "general": {
        "login": "Accedi",
        "sign_up": "Registrati",
        "select": "Seleziona"
    }
}
